import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=70b411ae&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b411ae",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CButton: require('@chakra-ui/vue').CButton, CStack: require('@chakra-ui/vue').CStack, CFlex: require('@chakra-ui/vue').CFlex})
